import useFamilyMembers from './useFamilyMembers';

export default useFamilyMembers;
